// Canonical builder for the widget install snippet. Used by:
//   • docs quickstart (apps/docs/src/components/WidgetSnippet.astro)
//   • dashboard agent page (apps/dashboard/src/routes/agents/…)
//   • widget's gen-sri.mjs preview output
//
// Master plan §608: "Shared CI fixture with docs quickstart = one bug
// surface." A single generator means a change to the data-* surface can't
// drift between the quickstart and the copy-from-dashboard paste.
//
// Pure — no fs, no DOM, no Preact. The integrity hash + cdn url + agent id
// are all inputs; the caller is responsible for loading the SRI manifest
// at build time (docs/dashboard read it via fs, the widget package emits it
// from `scripts/gen-sri.mjs`).
const SESSION_PLACEHOLDER = 'cs_REPLACE_ME';
// Build the `<script>` tag. Multi-line with two-space indent — matches what
// the docs + gen-sri.mjs already output byte-for-byte.
export function buildWidgetSnippet(opts) {
    const lines = [
        '<script',
        `  src="${opts.cdnUrl}"`,
        `  integrity="${opts.integrity}"`,
        '  crossorigin="anonymous"',
        '  data-cortex-widget',
        `  data-api-base="${opts.apiBase}"`,
        `  data-agent-id="${opts.agentId}"`,
        `  data-session-token="${opts.sessionToken ?? SESSION_PLACEHOLDER}"`,
    ];
    if (opts.accent)
        lines.push(`  data-accent="${opts.accent}"`);
    if (opts.position)
        lines.push(`  data-position="${opts.position}"`);
    lines.push('></script>');
    return lines.join('\n');
}
// npm-style install hint for the SDK path. The `<script>` tag is the
// primary install; this variant is for callers who want to control the
// widget lifecycle from their own bundle (React apps, Next.js, etc.).
// Kept in the same module so the two code paths stay in lock-step.
export function buildWidgetNpmSnippet(opts) {
    return [
        "import { mountWidget } from '@cortex/sdk/widget';",
        '',
        'mountWidget({',
        `  agentId: '${opts.agentId}',`,
        `  apiBase: '${opts.apiBase}',`,
        "  sessionToken: 'cs_REPLACE_ME',",
        '});',
    ].join('\n');
}
//# sourceMappingURL=widget-snippet.js.map